/* -------------- Operation based interfaces -------------- */

// LIST
export interface CDNFileListItem {
    cdnFileId: string;
    name: string;
    imageUrl: string;
    extension: string;
    size: string;
    width: number;
    height: number;
    creationDate: string;
}

export interface CDNFileListApiResponse {
    result: {
        items: CDNFileListItem[];
    };
    error: string | null;
    isSuccessful: boolean;
}

// GET
export interface CDNFileDetail {
    cdnFileId: string;
    name: string;
    imageUrl: string;
}

export interface CDNFileGetApiResponse {
    result: {
        cdnFileId: string;
        name: string;
        imageUrl: string;
    }
    error: string | null;
    isSuccessful: boolean;
}

// ADD & UPDATE
export interface CDNFileData {
    name: string;
    image: File | null;
    cdnFileId?: string;
}

export const defaultCDNFileData: CDNFileData = {
	name: "",
	image: null,
	cdnFileId: "",
};

// Page States
export type OperationStatus =
    | { type: "idle" }
    | { type: "loading"; operation: "add" | "fetch" | "update" | "delete" }
    | { type: "error"; operation: string; message: string };
